/* unplugin-vue-components disabled */import { render } from "./w-alert.vue?vue&type=template&id=a2ace886&scoped=true&ts=true"
import script from "./w-alert.vue?vue&type=script&lang=ts"
export * from "./w-alert.vue?vue&type=script&lang=ts"

import "./w-alert.vue?vue&type=style&index=0&id=a2ace886&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2ace886"]])

export default __exports__